import { render, staticRenderFns } from "./QualityVerification.vue?vue&type=template&id=c06c4566&scoped=true&"
import script from "./QualityVerification.vue?vue&type=script&lang=js&"
export * from "./QualityVerification.vue?vue&type=script&lang=js&"
import style0 from "./QualityVerification.vue?vue&type=style&index=0&id=c06c4566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06c4566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c06c4566')) {
      api.createRecord('c06c4566', component.options)
    } else {
      api.reload('c06c4566', component.options)
    }
    module.hot.accept("./QualityVerification.vue?vue&type=template&id=c06c4566&scoped=true&", function () {
      api.rerender('c06c4566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/components/QualityVerification.vue"
export default component.exports